import * as React from 'react';
import { useState } from 'react';
import { useCreatePhoneCallCategoryMutation } from '../../../../../queries/PhoneCall/usePhoneCallCategoryMutations';
import { Button } from '../../../../../web/components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../../../web/components-v2/Dialog';
import { Input } from '../../../../../web/components-v2/Input';
import { hotPink } from '../../../../styles/colors';
import { styleSheet } from '../styles';

interface IProps {
	onRequestClose(success: boolean): void;
}

export const CategoryNewModal: React.FC<IProps> = ({ onRequestClose }) => {
	const [categoryName, setCategoryName] = useState('');

	const createCategory = useCreatePhoneCallCategoryMutation({ onSuccess: () => onRequestClose(true) });

	const handleSave = () => {
		createCategory.mutate({ hexColor: hotPink, name: categoryName });
	};

	const handleOpenChange = (isOpen: boolean) => {
		if (!isOpen) {
			onRequestClose?.(false);
		}
	};

	const handleCategoryName = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCategoryName(event?.target?.value);
	};

	return (
		<Dialog open={true} onOpenChange={handleOpenChange}>
			<DialogPopup>
				<DialogHeader>
					<DialogTitle>New Category</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<Input
						id='filter-name-input'
						aria-label='Category Name'
						placeholder='Category Name'
						onChange={handleCategoryName}
						styles={[styleSheet.nameInput]}
						type='text'
						value={categoryName}
					/>
				</DialogBody>
				<DialogFooter>
					<Button variant='primary' onClick={handleSave} isLoading={createCategory.isPending}>
						Save
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
